import { COUPONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

//  PUBLISH AND UNPUBLISH AND REVOKE
const publish_coupon_request = () => {
  return {
    type: couponsTypes.publish.request
  }
}

const publish_coupon_success = (response) => {
  return {
    type: couponsTypes.publish.success,
    payload: response.data
  }
}

const publish_single_coupon_success = (response) => {
  return {
    type: couponsTypes.publish.single,
    payload: response.data
  }
}

const publish_coupon_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: couponsTypes.publish.failure,
    payload: messages
  }
}

const publish_coupon = (coupon_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_coupon_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(COUPONS_ROUTES.publish, {id: coupon_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The coupon status has changed to: Published.')
      if ( index ) {
        dispatch( publish_coupon_success(response) )

      } else {
        dispatch( publish_single_coupon_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing coupon"]
      }
      dispatch( publish_coupon_failure( errors ) )
    })
  }
}

const unpublish_coupon = (coupon_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_coupon_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(COUPONS_ROUTES.unpublish, {id: coupon_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The coupon status has changed to: Draft.')
      if ( index ) {
        dispatch( publish_coupon_success(response) )

      } else {
        dispatch( publish_single_coupon_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unpublishing coupon"]
      }
      dispatch( publish_coupon_failure( errors ) )
    })
  }
}

const revoke_coupon = (coupon_id, index=false, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_coupon_request() )
    const reqParams = index ? {
      index: true,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: false}
    // Request
    axios.post(
      formatRoute(COUPONS_ROUTES.revoke, {id: coupon_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The coupon status has changed to: Revoked.')
      if ( index ) {
        dispatch( publish_coupon_success(response) )

      } else {
        dispatch( publish_single_coupon_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error revoking coupon."]
      }
      dispatch( publish_coupon_failure( errors ) )
    })
  }
}

export {
  publish_coupon,
  unpublish_coupon,
  revoke_coupon,
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/publish.js